import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "flex mb-4" }
const _hoisted_3 = { class: "ml-auto" }
const _hoisted_4 = { class: "buttonRowWrapper" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-add" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-delete" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "text-center" }

import {onBeforeUnmount, onMounted, reactive, ref} from "vue";
import RecipientService from "@/utilities/services/entities/RecipientService";
import {ErrorLocationType, PopupType} from "@/utilities/enums/Enums";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {Store, StringHelper} from "@bryntum/grid";
import {checkboxColumnConfig, defaultSpaceAroundTableOnPage} from "@/AppConfig";
import dialog from "@/components/dialog";
import {useI18n} from "vue-i18n";
import Error from "@/components/Error.vue";
import GridInputFilter from "@/components/GridInputFilter.vue";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import {useGlobalStore} from "@/stores/GlobalStore";
import DotMenuFactoryHelper from "@/utilities/helpers/DotMenuFactoryHelper";
import Recipient from "@/models/entities/Recipient";
import {updateServiceConfig} from "@/utilities/helpers/ServiceConfigHelper";



export default /*#__PURE__*/_defineComponent({
  __name: 'RecipientTab',
  setup(__props) {

const {t} = useI18n();
const globalStore = useGlobalStore();

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};

const selectedItems = ref<Recipient[]>([]);
const recipientService = new RecipientService();
let clicked = false;


const gridDataIsLoading = ref<boolean>(false);
const gridStore = new Store({
  sorters: [{
    field: 'displayName',
    ascending: true
  }]
})
const grid = ref(null)
const useGridConfig = {
  emptyText: t("general.noEntries"),
  headerMenuFeature: false,
  relayStoreEvents: true,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
    hideOnDelegateChange: true,
  },
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  },
  columns : {
    data: [
      {
        id:'displayName',
        field: 'displayName',
        text: t('recipient.tabs.recipient.grid.name'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id:'email',
        field: 'email',
        text: t('recipient.tabs.recipient.grid.email'),
        flex: 1,
        type: "template",
        template: ({value}:any) => {
          return StringHelper.xss`${value ?? ""}`;
        }
      },
      {
        id: 'editButton',
        field: 'editButton',
        text: '',
        width: 36,
        minWidth: 49,
        resizable: false,
        sortable: false,
        tooltipRenderer : () => StringHelper.xss`<span class="text-[#013C74]">${t('general.edit')}</span>`,
        type: "template",
        template: () => {
          return `<div class='gridRowButton'><span class='icon-edit'></span></div>`;
        },
      },
      {
        id: 'deleteButton',
        field: 'deleteButton',
        text: '',
        width: 36,
        minWidth: 49,
        resizable: false,
        sortable: false,
        tooltipRenderer : () => StringHelper.xss`<span class="text-[#013C74]">${t('general.delete')}</span>`,
        type: "template",
        template: () => {
          return `<div class='gridRowButton'><span class='icon-delete'></span></div>`;
        },
      },
      {
        id:'menu',
        text	: '',
        width   : 36,
        minWidth: 49,
        type	: 'widget',
        align: "center",
        hideable: false,
        resizable: false,
        sortable: false,
        filterable: false,
        widgets : [{
          type	 : 'button',
          width: 36,
          icon	 : 'icon-more-menu',
          onAction : ({ source: btn }:any) => {
            const menu = DotMenuFactoryHelper.build(btn.cellInfo.record.data, [
              {
                text: t('general.details'),
                cls: 'color',
                weight: 100,
                onItem : async ({menu}:any) => {
                  await openDetailPopup(menu.record as Recipient);
                }
              },
              {
                text: t('general.edit'),
                cls: 'color',
                weight: 100,
                onItem : async ({ menu }:any) => {
                  await openEditPopup(menu.record as Recipient);
                }
              },
              {
                text: t('general.delete'),
                cls: 'color',
                weight: 100,
                onItem : async ({ menu }:any) => {
                  const answer = await dialog
                      .okText(t("general.delete"))
                      .cancelText(t("general.cancel"))
                      .title(t("general.deleteEntity", {entity: t("general.entities.recipient")}))
                      .confirm(t("recipient.tabs.recipient.confirmDeletionSingle", {name: menu.record.name}));

                  if (answer) {
                    const resp = await recipientService.delete(menu.record as Recipient, ErrorLocationType.table);
                    if(!resp) return;

                    gridStore.applyChangeset({removed:[{id:menu.record.id}]});
                    globalStore.showSuccess(t('general.deleted'));
                  }
                }
              }
            ]);
            menu.alignTo({ target: btn })
            menu.show();
          }
        }]
      }
    ],
    listeners:{
    }
  },
  store: gridStore,
  listeners: {
    selectionChange(event:any) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedItems.value = selectedItems.value.concat(event.selected.map(f=> f.data))
      selectedItems.value = selectedItems.value.filter(f => !event.deselected.map(fd => fd.data).some(fd => fd?.id === f?.id));
    },
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.getCount();
    },
    async cellClick({column, record}:any){
      if(clicked) return;
      clicked = true;

      if(column.data.field === 'editButton'){
        await openEditPopup(record.originalData as Recipient);
      }
      if(column.data.field === 'deleteButton'){
        const answer = await dialog
            .okText(t("general.delete"))
            .cancelText(t("general.cancel"))
            .title(t("general.deleteEntity", {entity: t("general.entities.recipient")}))
            .confirm(t("recipient.tabs.recipient.confirmDeletionSingle", {name: record.name}));

        if (answer) {
          const resp = await recipientService.delete(record.originalData as Recipient, ErrorLocationType.table);
          if(!resp) return;

          gridStore.applyChangeset({removed:[{id:record.id}]});
          globalStore.showSuccess(t('general.deleted'));
        }
      }

      clicked = false
    }
  },
  height: currentWindowHeight,
}
const gridConfig = reactive(useGridConfig)


const setGridData = async () => {
  const resp = await recipientService.getForUser(ErrorLocationType.table);
  if(!resp) return;

  gridStore.data = resp;
}

const openEditPopup = async (recipient:Recipient|null = null) => {
  // ensure associations are set, if the update context is used
  if(recipient){
    const recipientWithAssociations = await recipientService.getListAssociations(recipient, ErrorLocationType.popup);
    if(!recipientWithAssociations) return;

    recipient = recipientWithAssociations;
  }

  globalStore.openPopup({
    data: recipient ?? new Recipient(),
    action: async () => {
      const recipient = globalStore.modal.contentObject as Recipient;
      const resp = recipient.id >= 0
          ? await recipientService.update(recipient, ErrorLocationType.popup)
          : await recipientService.create(recipient, ErrorLocationType.popup);
      if(!resp) return;

      if(recipient.id < 0) {
        recipient.id = resp.id;
        recipient.createdAt = resp.createdAt;
      }

      // in case of an update bryntum automatically replaces the entry with the same ID
      gridStore.add(recipient);
      await gridStore.sort(gridStore.sorters);

      globalStore.closeModal();
      globalStore.showSuccess(t("general.saved"));
    },
    resetButton:false,
    title: recipient
        ? t("recipient.tabs.recipient.popups.edit.title.update")
        : t("recipient.tabs.recipient.popups.edit.title.add"),
    type: PopupType.recipientEdit,
    big:true
  })
}

const openDetailPopup = async (recipient:Recipient) => {
  const recipientWithAssociations = await recipientService.getListAssociations(recipient, ErrorLocationType.popup);

  globalStore.openPopup({
    data: recipientWithAssociations ?? recipient,
    resetButton:false,
    title: t("recipient.tabs.recipient.popups.details.title"),
    type: PopupType.recipientDetails,
    big:true
  })
}

const deleteSelection = async () => {
  if(!selectedItems.value?.some(()=>true)) return;

  const answer = await dialog
      .okText(t('general.delete'))
      .cancelText(t('general.cancel'))
      .title(t("general.deleteEntity", {entity: t("general.entities.recipient")}))
      .confirm(t('recipient.tabs.recipient.confirmDeletionMulti', {count:selectedItems.value.length}));

  if (answer) {
    let someEntriesFailed = false;

    for (const recipient of selectedItems.value){
      const resp = await recipientService.delete(recipient, ErrorLocationType.table);
      if(!resp){
        someEntriesFailed = true;
        continue;
      }

      gridStore.applyChangeset({removed:[{id:recipient.id}]});
    }

    if (someEntriesFailed) return;

    globalStore.showSuccess(t("general.deleted"));
  }
}


onMounted(async ()=> {
  recalcGridHeight()
  window.addEventListener('resize', recalcGridHeight)

  gridDataIsLoading.value = true
  await updateServiceConfig();
  await setGridData();
  gridDataIsLoading.value = false
})

onBeforeUnmount(()=> {
  window.removeEventListener('resize', recalcGridHeight)

  globalStore.gridStore = null
  globalStore.gridColumnStore = null
  globalStore.currentItems = 0
  globalStore.allItems = 0
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Error, {
        errorLoc: _unref(ErrorLocationType).table
      }, null, 8, ["errorLoc"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(GridInputFilter, {
              gridStore: _unref(gridStore),
              hideFilterButton: true
            }, null, 8, ["gridStore"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "primary symetric36 mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openEditPopup())),
            title: _unref(t)('general.add')
          }, _hoisted_7, 8, _hoisted_5),
          _createElementVNode("button", {
            class: "primary symetric36 mr-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (deleteSelection())),
            disabled: !selectedItems.value.some(()=>true),
            title: _unref(t)('general.delete')
          }, _hoisted_10, 8, _hoisted_8)
        ]),
        _createVNode(_unref(BryntumGrid), _mergeProps({
          ref_key: "grid",
          ref: grid
        }, gridConfig, { readOnly: true }), null, 16)
      ])
    ], 512), [
      [_vShow, !gridDataIsLoading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, gridDataIsLoading.value]
    ])
  ]))
}
}

})